import React from 'react';
import styles from './WorkplaceDoctorStatisticsModalButton.module.scss';
import Tooltip from '../../../Components/Popup/Tooltip';
import Text from '../../../Components/Base/Text/Text';

interface Props {
	onClick: () => void;
}

const WorkplaceDoctorStatisticsModalButton: React.FC<Props> = ({ onClick }) => {
	return (
		<div className={styles.wrapper}>
			<Tooltip
				trigger={
					<div onClick={onClick} className={styles.toggleButton}>
						<img
							width='22px'
							src='/dist/icons/chart-waterfall-solid-full.svg'
							alt='bell'
						/>
					</div>
				}>
				<Text tx={'base.statistics'} />
			</Tooltip>
		</div>
	);
};

export default WorkplaceDoctorStatisticsModalButton;
